import React from 'react';
import PropTypes from 'prop-types';
import { WhiteTick } from '../../assets';
import styles from './SuccessNotification.module.css';

export const SubmitConfirmModal = ({
  subHeading,
  heading,
  buttonText,
  onButtonClick,
  hideSuccessTick
}) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        {!hideSuccessTick && <div className={styles.checkmarkIcon}><img className={styles.imageStyle} src={WhiteTick} /></div>}
        <div className={styles.title} >{heading}</div>
        <p className={styles.subTitle}>{subHeading}</p>
        <button key='view-application' className={styles.primaryButton}
          onClick={onButtonClick ? onButtonClick : null}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

SubmitConfirmModal.propTypes = {
  heading: PropTypes.string,
  onButtonClick: PropTypes.func,
  buttonText: PropTypes.string,
  subHeading: PropTypes.string,
  hideSuccessTick: PropTypes.bool
};
